import PropTypes from 'prop-types';
import React from 'react';
import { Consumer as PageConsumer } from '../../../../contexts/PageContext';

import './CallToActionButtons.scss';

export default class CallToActionButtons extends React.PureComponent {
    constructor(props) {
        super(props);

        this.buttons = {
            FOLLOW: {
                action: 'follow',
                label: 'Follow',
                altLabel: 'Following',
                classes: 'purple-white-btn',
                altClasses: 'white-grey-btn',
                loginDescription: 'follow-company',
            },
            INVITE: {
                link: '/users/connections/invite',
                label: 'Invite Friends',
                classes: 'white-grey-btn sticky-hide',
            },
            REVIEW: {
                link: this.props.userId
                    ? `/company/review-${this.props.companyUrl}`
                    : '/please-register',
                label: 'Write a Review',
                classes: 'white-grey-btn sticky-hide',
                loginDescription: 'login-to-review',
            },
        };
    }

    handleFollowClick = () => {
        // eslint-disable-next-line no-unused-expressions
        !this.props.isFollowed
            ? this.props.followCompany(this.props.companyId, this.props.userId)
            : null;
    };

    renderButtonWrapper = (
        buttonKey,
        wrapAuth,
        contextSurveyTrigger,
        isLoggedIn
    ) => {
        const buttonData = this.buttons[buttonKey];
        const classes = `company-header-button ${
            this.props.isFollowed && buttonData.altClasses
                ? buttonData.altClasses
                : buttonData.classes
        }`;
        const value =
            this.props.isFollowed && buttonData.altLabel
                ? buttonData.altLabel
                : buttonData.label;
        const buttonInput = (
            <input
                type="button"
                readOnly
                className="lato-bold"
                value={value}
                key={buttonKey}
            />
        );
        let usedButton = (
            <a href={buttonData.link} className={classes} key={buttonKey}>
                {buttonInput}
            </a>
        );
        const company = {
            companyName: this.props.companyName,
            companyId: this.props.companyId,
            logo: this.props.logo,
        };
        if (buttonData.action) {
            usedButton = wrapAuth(
                'company-header',
                // eslint-disable-next-line jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events
                <div
                    onClick={isLoggedIn ? this.handleFollowClick : () => {}}
                    className={classes}
                    key={buttonKey}
                >
                    {buttonInput}
                </div>,
                { login_trigger: buttonData.loginDescription }
            );
        } else if (buttonKey === 'REVIEW') {
            usedButton = wrapAuth(
                'review-button',
                // eslint-disable-next-line jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events
                <div
                    onClick={() => contextSurveyTrigger(true, company)}
                    className={classes}
                    key={buttonKey}
                >
                    {buttonInput}
                </div>,
                { login_trigger: buttonData.loginDescription }
            );
        }

        return usedButton;
    };

    render() {
        return (
            <React.Fragment>
                <PageConsumer>
                    {(context) => {
                        return ['FOLLOW', 'INVITE', 'REVIEW'].map((key) =>
                            this.renderButtonWrapper(
                                key,
                                context.wrapAuth,
                                context.toggleJobReviewSurvey,
                                context.isLoggedIn()
                            )
                        );
                    }}
                </PageConsumer>
            </React.Fragment>
        );
    }
}

CallToActionButtons.propTypes = {
    /**
     * The company's url hash
     */
    companyUrl: PropTypes.string,
    /**
     * The company's ID
     */
    companyId: PropTypes.number,
    /**
     *  does user follow company
     */
    isFollowed: PropTypes.bool,
    /**
     * The company's follow callback
     */
    followCompany: PropTypes.func,
    /**
     *  session userId
     */
    userId: PropTypes.number,
    logo: PropTypes.string,
    companyName: PropTypes.string,
};

CallToActionButtons.defaultProps = {
    companyUrl: '',
    companyId: 1,
    userId: 1,
    logo: '',
    isFollowed: 0,
    companyName: '',
    followCompany: () => {},
};
